"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockType = void 0;
/**
 * 块类型
 */
var BlockType;
(function (BlockType) {
    BlockType[BlockType["PAGE"] = 0] = "PAGE";
    BlockType[BlockType["TEXTAREA"] = 1] = "TEXTAREA";
    BlockType[BlockType["LINK_PAGE"] = 2] = "LINK_PAGE";
    BlockType[BlockType["TODO"] = 3] = "TODO";
    BlockType[BlockType["LIST"] = 4] = "LIST";
    BlockType[BlockType["ORDER_LIST"] = 5] = "ORDER_LIST";
    BlockType[BlockType["FOLD_LIST"] = 6] = "FOLD_LIST";
    BlockType[BlockType["HEADER"] = 7] = "HEADER";
    BlockType[BlockType["IMAGE"] = 8] = "IMAGE";
    BlockType[BlockType["DIVIDER"] = 9] = "DIVIDER";
    BlockType[BlockType["COLUMN_LIST"] = 10] = "COLUMN_LIST";
    BlockType[BlockType["COLUMN"] = 11] = "COLUMN";
    BlockType[BlockType["QUOTE"] = 12] = "QUOTE";
    BlockType[BlockType["MARK"] = 13] = "MARK";
    BlockType[BlockType["FILE"] = 14] = "FILE";
    BlockType[BlockType["FOLDER"] = 15] = "FOLDER";
    BlockType[BlockType["REFERENCE"] = 16] = "REFERENCE";
    BlockType[BlockType["COLLECTION"] = 17] = "COLLECTION";
    BlockType[BlockType["COLLECTION_VIEW_PAGE"] = 18] = "COLLECTION_VIEW_PAGE";
    BlockType[BlockType["COLLECTION_VIEW"] = 19] = "COLLECTION_VIEW";
    BlockType[BlockType["EMBED"] = 20] = "EMBED";
    BlockType[BlockType["BOOKMARK"] = 21] = "BOOKMARK";
    BlockType[BlockType["COPY_INDICATOR"] = 22] = "COPY_INDICATOR";
    BlockType[BlockType["EQUATION"] = 23] = "EQUATION";
    BlockType[BlockType["SUMMARY_PAGE"] = 24] = "SUMMARY_PAGE";
    BlockType[BlockType["CODE"] = 25] = "CODE";
    BlockType[BlockType["EXTERNAL_FILE"] = 26] = "EXTERNAL_FILE";
    BlockType[BlockType["TABLE"] = 27] = "TABLE";
    BlockType[BlockType["TABLE_ROW"] = 28] = "TABLE_ROW";
    BlockType[BlockType["REFERENCE_COLLECTION"] = 29] = "REFERENCE_COLLECTION";
    BlockType[BlockType["TEMPLATE"] = 30] = "TEMPLATE";
    BlockType[BlockType["SYNC_CONTAINER"] = 31] = "SYNC_CONTAINER";
    BlockType[BlockType["SYNC_REFERENCE"] = 32] = "SYNC_REFERENCE";
    BlockType[BlockType["REFERENCE_COLLECTION_PAGE"] = 33] = "REFERENCE_COLLECTION_PAGE";
    BlockType[BlockType["PDF_PAGE"] = 34] = "PDF_PAGE";
    BlockType[BlockType["PDF_ANNOTATION"] = 35] = "PDF_ANNOTATION";
    BlockType[BlockType["MIND_MAPPING"] = 36] = "MIND_MAPPING";
    BlockType[BlockType["MIND_MAPPING_PAGE"] = 37] = "MIND_MAPPING_PAGE";
    BlockType[BlockType["TOGGLE_HEADER"] = 38] = "TOGGLE_HEADER";
    BlockType[BlockType["AD"] = 39] = "AD";
    BlockType[BlockType["CHART"] = 40] = "CHART";
    BlockType[BlockType["CHART_PAGRE"] = 41] = "CHART_PAGRE";
})(BlockType = exports.BlockType || (exports.BlockType = {}));
